import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const Experience = () => {
  const WorkIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
    </svg>
  );
  const experiences = [
    {
      id: 1,
      company: "Nexsys IT Consulting - Mumbai",
      position: "Software Engineer | PLSQL Developer",
      duration: "December 2024 - Present",
      points: [
        "Accelya | SkyChain Application (Air Cargo Management System)",
        "Designed, developed, and optimized PL/SQL scripts, stored procedures, and triggers to streamline cargo operations and maximize revenue efficiency.",
        "Enhanced query performance, indexing strategies, and execution plans, ensuring high-speed data processing and system scalability.",
        "Engineered robust database structures to improve operational efficiency, reduce latency.",
      ],
      icon: <WorkIcon />,
    },
    {
      id: 2,
      company: "Tata Consultancy Services - Pune",
      position: "Oracle PLSQL Developer",
      duration: "August 2021 - December 2024",
      points: [
        "Managed and optimized Oracle databases with a customer base of 218+ million users, ensuring peak performance, high availability, and scalability while handling a large volume of transactions and data efficiently.",
"Engineered and fine-tuned 20+PL/SQL scripts, stored procedures,functions, cursors and triggers optimizing Oracle SQL queries through efficient joins, indexing, partitioning, and views to enhance application functionalities and improve system performance."
      ],
      icon: <WorkIcon />,
    },
  ];

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif", marginTop: "40px" }}>
      <p className="project-heading">
        Professional <span style={{ color: "#FFC107" }}>Experience</span>{" "}
      </p>
      <VerticalTimeline lineColor="#ddd">
        {experiences.map((exp) => (
          <VerticalTimelineElement
            key={exp.id}
            date={exp.duration}
            dateClassName="date"
            iconStyle={{
              color: "#000",
              boxShadow: "0 0 0 4px #ddd, inset 0 5px 0 rgba(0,0,0,.08)",
              fontSize: "2rem",
              zIndex: "5",
            }}
            contentStyle={{
              background: "#1f1f21",
              color: "#000",
              borderRadius: "20px",
              padding: "20px",
            }}
            contentArrowStyle={{
              borderRight: "7px solid rgba(255,255,255,0.8)",
            }}
            icon={exp.icon}
          >
            <h3
              style={{
                margin: 0,
                fontSize: "2rem",
                fontWeight: 600,
              }}
            >
              {exp.position}
            </h3>
            <h4
              style={{
                margin: "5px 0 10px",
                fontSize: "1.3rem",
                fontWeight: 500,
              }}
            >
              {exp.company}
            </h4>
            <ul
              style={{
                paddingLeft: "20px",
                margin: "10px 0 0",
              }}
            >
              {exp.points.map((point, index) => (
                <li
                  key={index}
                  style={{
                    marginBottom: "10px",
                    fontSize: "1rem",
                  }}
                >
                  {point}
                </li>
              ))}
            </ul>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  );
};

export default Experience;
